/* eslint @typescript-eslint/no-unused-vars: ["error", { "args": "none" }] */

// This function like a TFunction from 'i18next', specifically for i18n-extract key extractor

const t = (key: string, value: string) => key;

export default t;
